import { Link } from 'react-router-dom';
import ComicCard from '@/components/feature/ComicCard';
import type { Comic } from '@/mocks/comics';

interface ComicSectionProps {
  title: string;
  subtitle?: string;
  comics: Comic[];
  viewAllLink?: string;
  viewAllLabel?: string;
  layout?: 'grid' | 'horizontal';
  bgClass?: string;
}

export default function ComicSection({
  title,
  subtitle,
  comics,
  viewAllLink,
  viewAllLabel = '查看全部',
  layout = 'grid',
  bgClass = 'bg-background-50',
}: ComicSectionProps) {
  const displayComics = layout === 'grid' ? comics.slice(0, 8) : comics.slice(0, 6);

  return (
    <section className={`py-10 md:py-14 ${bgClass}`}>
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-6">
          <div>
            <h2 className="section-title">{title}</h2>
            {subtitle && <p className="section-subtitle">{subtitle}</p>}
          </div>
          {viewAllLink && (
            <Link
              to={viewAllLink}
              className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap transition-colors"
            >
              {viewAllLabel}
              <i className="ri-arrow-right-line"></i>
            </Link>
          )}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 gap-4 md:gap-5">
          {displayComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}